






















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import VehicleType from '@/core/interfaces/VehicleType';
import axios from 'axios';
import confirmDeleteDialog from '@/core/confirm-delete';

@Component({
    components: {},
})
export default class VehicleTypeRegistrationData extends Vue {
    @Prop({ required: true })
    vehicleType!: VehicleType;

    newAction = '';

    newCause = '';

    edittingAction = '';

    edittingActionId: number | null = null;

    edittingCause = '';

    edittingCauseId: number | null = null;

    actions: { action: string, id: number }[] = [];

    causes: { cause: string, id: number }[] = [];

    loading = false;

    mounted(): void {
        this.fetchData();
    }

    async fetchData(): Promise<void> {
        this.loading = true;
        await Promise.all([
            this.fetchCauses(),
            this.fetchActions(),
        ]);
        this.loading = false;
    }

    async fetchActions(): Promise<void> {
        const response = await axios.get(
            `${process.env.VUE_APP_ALARMCENTER_API_URL}/admin/vehicle-types/${this.vehicleType.id}/possible-actions`,
        );
        this.actions = response.data;
    }

    async fetchCauses(): Promise<void> {
        const response = await axios.get(
            `${process.env.VUE_APP_ALARMCENTER_API_URL}/admin/vehicle-types/${this.vehicleType.id}/possible-causes`,
        );
        this.causes = response.data;
    }

    async deleteAction(id: number): Promise<void> {
        const confirm = await confirmDeleteDialog(this, 'Are you sure you want to delete this action?', {
            title: 'Confirm Deletion',
            okTitle: 'Yes',
            cancelTitle: 'No',
        });

        if (!confirm) {
            return;
        }

        this.loading = true;

        await axios.delete(`${process.env.VUE_APP_ALARMCENTER_API_URL}/admin/vehicle-types/${this.vehicleType.id}/possible-actions/${id}`);
        await this.fetchActions();

        this.loading = false;
    }

    async deleteCause(id: number): Promise<void> {
        const confirm = await confirmDeleteDialog(this, 'Are you sure you want to delete this cause?', {
            title: 'Confirm Deletion',
            okTitle: 'Yes',
            cancelTitle: 'No',
        });

        if (!confirm) {
            return;
        }

        this.loading = true;

        await axios.delete(`${process.env.VUE_APP_ALARMCENTER_API_URL}/admin/vehicle-types/${this.vehicleType.id}/possible-causes/${id}`);
        await this.fetchCauses();

        this.loading = false;
    }

    async addAction(): Promise<void> {
        this.loading = true;

        await axios.post(`${process.env.VUE_APP_ALARMCENTER_API_URL}/admin/vehicle-types/${this.vehicleType.id}/possible-actions`, {
            action: this.newAction,
        });
        await this.fetchActions();

        this.newAction = '';
        this.loading = false;
    }

    async addCause(): Promise<void> {
        this.loading = true;

        await axios.post(`${process.env.VUE_APP_ALARMCENTER_API_URL}/admin/vehicle-types/${this.vehicleType.id}/possible-causes`, {
            cause: this.newCause,
        });
        await this.fetchCauses();

        this.newCause = '';
        this.loading = false;
    }

    async saveAction(): Promise<void> {
        if (!this.edittingActionId) {
            return;
        }

        this.loading = true;

        await axios.put(`${process.env.VUE_APP_ALARMCENTER_API_URL}/admin/vehicle-types/${this.vehicleType.id}/possible-actions/${this.edittingActionId}`, {
            action: this.edittingAction,
        });
        this.$bvModal.hide('edit-action');
        await this.fetchActions();

        this.edittingAction = '';
        this.edittingActionId = null;
        this.loading = false;
    }

    async saveCause(): Promise<void> {
        if (!this.edittingCauseId) {
            return;
        }

        this.loading = true;

        await axios.put(`${process.env.VUE_APP_ALARMCENTER_API_URL}/admin/vehicle-types/${this.vehicleType.id}/possible-causes/${this.edittingCauseId}`, {
            cause: this.edittingCause,
        });
        this.$bvModal.hide('edit-cause');
        await this.fetchCauses();

        this.edittingCause = '';
        this.edittingCauseId = null;
        this.loading = false;
    }
}
